export default {
  size: {
    extraSmall: '12px',
    small: '14px',
    regular: '16px',
    large: '18px',
  },
};
